
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3.906l12.375 5.156.625.281v2.656h-2v11h2v5H3v-5h2v-11H3V9.343l.625-.281 12-5zm0 2.188L6.625 10h18.75zM7 12v11h2V12H7zm4 0v11h2V12h-2zm4 0v11h2V12h-2zm4 0v11h2V12h-2zm4 0v11h2V12h-2zM5 25v1h22v-1H5z"}})])
          )
        }
      }
    